import { FOOTER_PRIVACY, FOOTER_TERMS, NAV_PRODUCT } from './landingText';
import { LEGAL } from "../../../onboarding/constants/onboardingText";


export interface FooterLink {
  title: string;
  url?: string;
  onClick?: () => void;
  target?: string;
}

export const FOOTER_LINKS_CONFIG: Omit<FooterLink, 'onClick'>[] = [
  { title: NAV_PRODUCT },
  { title: FOOTER_TERMS, url: LEGAL.TERMS_URL, target: '_blank' },
  { title: FOOTER_PRIVACY, url: LEGAL.PRIVACY_URL, target: '_blank' },
];
